import { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../../config";
import { Loader2, ChevronLeft, ChevronRight, Inbox, Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";

const AmbassadorList = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});

  useEffect(() => {
    const fetchList = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `${API_URL}/api/ambassador/ambassador?page=${page}&limit=10`,
        );

        setData(res.data.data || []);

        setPagination({
          total: res.data.count,
          totalPages: res.data.totalPages,
        });
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchList();
  }, [page]);

  // 🔥 STATUS BADGE
  const getStatusBadge = (status) => {
    const map = {
      New: "bg-primary",
      contacted: "bg-warning text-dark",
      resolved: "bg-success",
      qualified: "bg-info",
      lost: "bg-danger",
    };
    return `badge ${map[status] || "bg-secondary"} px-2 py-1`;
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-dark text-white">
        <Loader2 className="spin" size={50} />
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="card border-0 rounded-4">
        {/* HEADER */}
        <div className="card-header d-flex justify-content-between align-items-center border-0 btn-primary text-white">
          <div>
            <h5 className="fw-bold mb-0">Ambassador Leads</h5>
            <small className="">Manage ambassador applications</small>
          </div>

          <span className="badge px-3 py-2">{pagination?.total || 0}</span>
        </div>

        {/* TABLE */}
        <div className="table-responsive">
          <table className="table align-middle mb-0 text-white">
            <thead style={{ background: "#020617" }}>
              <tr className="text-secondary">
                <th>Name</th>
                <th>Email</th>
                <th>College</th>
                <th>Status</th>
                <th>Date</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((item) => (
                  <tr
                    key={item._id}
                    style={{
                      borderBottom: "1px solid #fff",
                      transition: "0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#fff")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = "transparent")
                    }
                  >
                    <td className="fw-semibold">{item.fullName}</td>

                    <td className="text-secondary">{item.email}</td>

                    <td>{item.college}</td>

                    <td>
                      <span className={getStatusBadge(item.status)}>
                        {item.status}
                      </span>
                    </td>

                    <td>{new Date(item.createdAt).toLocaleDateString()}</td>

                    {/* ACTION BUTTON */}
                    <td className="text-end">
                      <button
                        className="d-flex align-items-center gap-2 px-3 py-1"
                        style={{
                          border: "1px solid rgba(59,130,246,0.6)",
                          color: "#60a5fa",
                          background: "transparent",
                          borderRadius: "8px",
                          fontSize: "14px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#3b82f6";
                          e.currentTarget.style.color = "#fff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                          e.currentTarget.style.color = "#60a5fa";
                        }}
                        onClick={() => navigate(`/ambassador/${item._id}`)}
                      >
                        <Eye size={16} />
                        View
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-5">
                    <Inbox size={40} />
                    <p>No data found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION */}
        <div
          className=" d-flex justify-content-between align-items-center p-3"
          style={{ backgroundColor: "white" }}
        >
          <button
            className="btn btn-primary"
            style={{ background: "#fff", color: "#fff" }}
            disabled={page <= 1}
            onClick={() => setPage((p) => p - 1)}
          >
            <ChevronLeft /> Prev
          </button>

          <span className="text-black">
            Page {page} / {pagination.totalPages || 1}
          </span>

          <button
            className="btn btn-primary"
            style={{ background: "#fff", color: "#fff" }}
            disabled={page >= (pagination.totalPages || 1)}
            onClick={() => setPage((p) => p + 1)}
          >
            Next <ChevronRight />
          </button>
        </div>
      </div>

      {/* SPINNER */}
      <style>{`
        .spin {
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default AmbassadorList;
